import React, { Component } from "react";
import { connect } from "react-redux";
import HeaderFicheClient from "../FicheClient/HeaderFicheClient";
import AnnexeList from "../BalanceSheet/AnnexeList";
import { getTemporaryAnnexeFileLink } from "Utils";
import { setAnnexeTemporaryLink } from "Actions";
import { fetchAnnexeList, fetchEnabledAnnexeCategories } from "Thunks";
import styles from "../BalanceSheet/BalanceSheet.local.scss";
import AnnexeIframe from "../Common/iframes/AnnexeIframe";

class AnnexesPage extends Component {
  constructor(props) {
    super(props);
    let { uen, year } = this.props.match.params;
    this.state = {
      organizationUen: uen,
      year: year,
      loading: false,
      loadingIframe: false,
      hideIframe: false
    };
  }

  componentDidMount() {
    const { dispatch, lng } = this.props;
    dispatch(fetchAnnexeList(this.state.organizationUen));
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false });
    }, 500);
    dispatch(fetchEnabledAnnexeCategories({ lng }));
  }

  displayAnnexePDF = (id, filePath) => {
    const { token } = this.props;

    this.setState({ hideIframe: false, loadingIframe: true });
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.remove("hide");
    document.body.classList.add("hidden_overflow");
    this.props.dispatch(
      setAnnexeTemporaryLink(getTemporaryAnnexeFileLink(id, filePath, token))
    );

    setTimeout(() => {
      this.setState({ loadingIframe: false });
    }, 2000);
  };

  closeAnnexePDF = () => {
    this.setState({ hideIframe: true });
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
    document.body.classList.remove("hidden_overflow");

    this.props.dispatch(setAnnexeTemporaryLink(""));
  };

  render() {
    return (
      <div
        className={`page-content`}
        style={{
          backgroundColor: `#FAFBFB`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          minHeight: 800
        }}
      >
        <HeaderFicheClient
          currentPage="ANNEXES"
          handleOnClickPrepare={this.handleOnClickPrepare}
          handleOnClickDiaporama={this.handleOnClickDiaporama}
          uen={this.state.organizationUen}
          selectedYear={this.state.year}
        />
        {!this.state.loading ? (
          <AnnexeList
            displayAnnexePDF={this.displayAnnexePDF}
            closeAnnexePDF={this.closeAnnexePDF}
          />
        ) : (
          <div className={styles.ripple_loading_adapted}>
            <img src={"/img/Ripple-1s-150px.svg"} alt="" />
          </div>
        )}
        <AnnexeIframe
          hideIframe={this.state.hideIframe}
          srcIframe={this.props.temporaryFileLink.link}
          loadingIframe={this.state.loadingIframe}
          onCloseIframe={this.closeAnnexePDF}
        />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  temporaryFileLink: state.annexes.annexesList.temporaryFileLink,
  token: state.auth.token,
  synchro: state.fiduciary.data && state.fiduciary.data.synchro
});

export default connect(mapStateToProps)(AnnexesPage);



// WEBPACK FOOTER //
// ./src/components/Annexes/AnnexesPage.js